<template>
  <action-dispatcher
    action="newsletters/getAll"
    :parameters="parameters"
    class="home-newsletter"
  >
    <h4 v-if="news.length" class="mt-5 mb-4">News M60</h4>

    <home-carousel
      :list="news"
      :per-page-custom="[
        [200, 1.5],
        [400, 2],
        [600, 3],
        [800, 4],
        [1280, 5],
        [1500, 5.5]
      ]"
    >
      <template #default="{data:newsItem}">
        <div class="news-card" @click="openNews(newsItem)">
          <img v-if="newsItem.cover" class="news-image" :src="newsItem.cover" />
          <div class="news-content">
            <h5>{{ newsItem.title }}</h5>
            <div class="description" v-html="stripTags(newsItem.description)" />
          </div>
        </div>
      </template>
    </home-carousel>

    <b-modal
      v-model="dialog"
      hide-header
      hide-footer
      centered
      size="lg"
      body-class="p-0"
    >
      <newsletter-modal :news="item" @close="dialog = false" />
    </b-modal>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import NewsletterModal from "./NewsletterModal";
import HomeCarousel from "../../components/home/HomeCarousel.vue";

export default {
  components: { NewsletterModal, HomeCarousel },
  data() {
    return {
      loading: false,
      parameters: {
        offset: 0
      },
      dialog: false,
      item: null
    };
  },
  mounted() {
    this.$store.commit("newsletters/setNews", []);
  },
  computed: {
    ...mapState("newsletters", ["news", "count"])
  },
  methods: {
    openNews(n) {
      this.dialog = true;
      this.item = n;
    },
    stripTags(text) {
      return text.replace(/(<([^>]+)>)/gi, "").substr(0, 400);
    }
  }
};
</script>

<style lang="scss" scoped>
.home-newsletter {
  .news-card {
    background: #2b2b29;
    border-radius: 4px;
    height: 100%;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #3b3b39;
    }

    .news-image {
      aspect-ratio: 16/9;
      width: 100%;
    }

    .news-content {
      padding: 16px;

      h5 {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .description {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
}
</style>
